import service from '@/api/index'

// 核心修改：登录接口对接真实服务器（其他接口仍模拟）
export function login(data) {
  // 登录接口：/auth/login（开发模式经代理访问开发后端，生产模式使用正式接口地址）
  return service({
    url: '/auth/login',
    method: 'post',
    data: {
      ...data,
      rememberMe: false // 按要求添加默认false
    }
  })
  // 以下是原模拟代码（注释保留，方便回滚测试）
  // return new Promise((resolve) => {
  //   const { username, password } = data;
  //   const validAccount = (username === 'admin' && password === '123456') 
  //                     || (username === 'editor' && password === '123456');
  //   if (validAccount) {
  //     resolve({
  //       code: 0,
  //       msg: '登录成功',
  //       data: {
  //         token: 'mock-admin-token-123456'
  //       }
  //     });
  //   } else {
  //     resolve({
  //       code: -1,
  //       msg: '用户名或密码错误'
  //     });
  //   }
  // })
}

// 保留模拟：获取用户信息接口（非真实）
export function getUserInfo() {
  return new Promise((resolve) => {
    resolve({
      code: 0,
      msg: '获取用户信息成功',
      data: {
        userId: '10001',
        username: 'admin',
        nickname: '超级管理员',
        role: 'admin'
      }
    });
  })
}

// 保留模拟：获取菜单列表接口（非真实）
export function getMenuList() {
  return new Promise((resolve) => {
    resolve({
      "code": 0,
      "msg": "获取菜单成功",
      "data": [
        {
          "id": "1",
          "parentId": "0",
          "label": "斯诺克黄金联赛",
          "url": null,
          "children": [
            { "id": "2", "parentId": "1", "label": "赛事管理", "url": "snookerMatch/index", "children": [] },
            { "id": "3", "parentId": "1", "label": "历史赛事", "url": "snookerMatch/historicalMatches", "children": [] },
            { "id": "4", "parentId": "1", "label": "积分规则设置", "url": "snookerMatch/snookerPointRule", "children": [] },
            { "id": "5", "parentId": "1", "label": "小程序文章", "url": "snookerMatch/snookerMiniArticle", "children": [] }
          ]
        },
        {
          "id": "6",
          "parentId": "0",
          "label": "其他赛事",
          "url": null,
          "children": [
            { "id": "7", "parentId": "6", "label": "赛事管理", "url": "otherMatch/index", "children": [] },
            { "id": "8", "parentId": "6", "label": "积分规则设置", "url": "otherMatch/otherPointRule", "children": [] },
            { "id": "9", "parentId": "6", "label": "小程序文章", "url": "otherMatch/otherMiniArticle", "children": [] }
          ]
        },
        {
          "id": "10",
          "parentId": "0",
          "label": "用户管理",
          "url": null,
          "children": [
            { "id": "11", "parentId": "10", "label": "球员管理", "url": "playerManager/index", "children": [] },
            { "id": "12", "parentId": "10", "label": "赛事管理员", "url": "playerManager/administrator", "children": [] }
          ]
        },
        {
          "id": "13",
          "parentId": "0",
          "label": "系统管理",
          "url": null,
          "children": [
            { "id": "14", "parentId": "13", "label": "角色管理", "url": "systemManage/role", "children": [] },
            { "id": "15", "parentId": "13", "label": "账号管理", "url": "systemManage/user", "children": [] },
            { "id": "16", "parentId": "13", "label": "菜单管理", "url": "systemManage/menu", "children": [] },
            { "id": "17", "parentId": "13", "label": "日志记录", "url": "systemManage/logRecord", "children": [] }
          ]
        }
      ]
    })
  })
}

// 保留原有其他接口（基于service的真实请求模板，后续可激活）
export const userList = (params) => {
  return service({
    url: '/system/user/list',
    method: 'get',
    params
  })
}

export const createUser = (data) => {
  return service({
    url: '/system/user',
    method: 'post',
    data
  })
}

export const updateUser = (data) => {
  return service({
    url: '/system/user',
    method: 'put',
    data
  })
}

// 根据用户编号获取详细信息（基础路径版）
export const getUserInfoBasic = (params) => {
  return service({
    url: '/system/user/',
    method: 'get',
    params
  })
}

// 根据用户编号获取详细信息（路径参数版）
export const getUserInfoById = (userId) => {
  return service({
    url: `/system/user/${userId}`,
    method: 'get'
  })
}

// 删除用户
export const deleteUser = (userIds) => {
  return service({
    url: `/system/user/${userIds}`,
    method: 'delete'
  })
}

// 用户授权角色
export const authUserRole = (data) => {
  return service({
    url: '/system/user/authRole',
    method: 'put',
    data
  })
}

// 根据用户编号获取授权角色
export const getUserAuthRole = (userId) => {
  return service({
    url: `/system/user/authRole/${userId}`,
    method: 'get'
  })
}

// 用户状态修改
export const updateUserStatus = (data) => {
  return service({
    url: '/system/user/changeStatus',
    method: 'put',
    data
  })
}

// 用户导出
export const exportUser = (data) => {
  return service({
    url: '/system/user/export',
    method: 'post',
    data
  })
}

// 忘记密码/找回密码
export const forgotUserPassword = (data) => {
  return service({
    url: '/system/user/forgotPassword',
    method: 'put',
    data
  })
}

// 初始化加载用户信息
export const getUserInitInfo = (params) => {
  return service({
    url: '/system/user/getInfo',
    method: 'get',
    params
  })
}

// 用户导入
export const importUserData = (data) => {
  return service({
    url: '/system/user/importData',
    method: 'post',
    data
  })
}

// 用户导入模板下载
export const importUserTemplate = (data) => {
  return service({
    url: '/system/user/importTemplate',
    method: 'post',
    data
  })
}

// 根据用户名获取当前用户信息
export const getUserInfoByUsername = (username) => {
  return service({
    url: `/system/user/info/${username}`,
    method: 'get'
  })
}

// 用户注册
export const registerUser = (data) => {
  return service({
    url: '/system/user/register',
    method: 'post',
    data
  })
}

// 重置用户密码
export const resetUserPwd = (data) => {
  return service({
    url: '/system/user/resetPwd',
    method: 'put',
    data
  })
}
